/**
 * Login identifiers: full email or local-part (before @).
 */

export function normalizeLoginIdentifier(raw: unknown): string {
  return String(raw ?? '').trim().toLowerCase().replace(/\s+/g, '');
}

export function isBareLoginUsername(value: string): boolean {
  return Boolean(value) && !value.includes('@');
}

/** Local part of an email (`joseito` from `joseito@gmail.com`). */
export function emailLocalPart(email: string): string {
  const at = email.indexOf('@');
  if (at <= 0) return '';
  return email.slice(0, at);
}

export function defaultAuthEmail(localPart: string, domain: string): string {
  const local = normalizeLoginIdentifier(localPart);
  const host = String(domain ?? '').trim().toLowerCase().replace(/^@+/, '');
  if (!local || !host) return '';
  return `${local}@${host}`;
}

/** True when `email`'s local part equals `local` exactly. */
export function emailHasLocalPart(email: string, local: string): boolean {
  return emailLocalPart(email) === local;
}
